import { createAction, props } from '@ngrx/store';
export const setHartfordCoverPageInfo = createAction('[Custom PDF Report Modal] Set Hartford Cover Page Info', props());
